import React, { useState, useEffect, useMemo } from "react";

const TimeField = (props) => {
  const [showPickerDrop, setShowPickerDrop] = useState(false);

  const [view, setView] = useState(["day", "hour", "minutes"]);
  const [colWidth, setColWidth] = useState("33.3%");

  const [minDay, setMinDay] = useState(0);
  const [maxDay, setMaxDay] = useState(30);

  const [minHour, setMinHour] = useState(0);
  const [maxHour, setMaxHour] = useState(23);

  const [minMinutes, setMinMinutes] = useState(0);
  const [maxMinutes, setMaxMinutes] = useState(59);

  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [minutes, setMinutes] = useState(0);

  const widths = ["100%", "50%", "33.3%"];

  const timeFieldLabelValue = useMemo(() => {
    let response = "";

    const timeFieldView = props.view ? props.view : ["day", "hour", "minutes"];

    if (view.includes("day") && timeFieldView.includes("day")) {
      response += day > 1 ? `${day} Days ` : `${day} Day `;
    }

    if (view.includes("hour") && timeFieldView.includes("hour")) {
      response += hour > 1 ? `${hour} hrs ` : `${hour} hr `;
    }

    if (view.includes("minutes") && timeFieldView.includes("minutes")) {
      response += minutes > 1 ? `${minutes} min` : `${minutes} mins`;
    }

    return response;
  }, [day, hour, minutes, props.view, view]);

  const applyDurationChange = (nextDay, nextHour, nextMinutes) => {
    const valueInMinutes = nextDay * 1440 + nextHour * 60 + nextMinutes;
    if (props.onChange) {
      props.onChange(valueInMinutes);
    }
  };

  /**
   * setting default value
   */
  useEffect(() => {
    if (
      props.defaultValue !== null &&
      props.defaultValue !== undefined &&
      props.defaultValue !== ""
    ) {
      const totalMinutes = parseInt(props.defaultValue, 10) || 0;
      const d = Math.floor(totalMinutes / 1440);
      const h = Math.floor((totalMinutes - d * 1440) / 60);
      const m = totalMinutes - d * 1440 - h * 60;
      setDay(d);
      setHour(h);
      setMinutes(m);
    }
  }, [props.defaultValue]);

  useEffect(() => {
    if (props.view) {
      setView(props.view);
      setColWidth(widths[props.view.length - 1]);
    }

    if (props.minDay !== undefined) {
      setMinDay(props.minDay);
    }

    if (props.maxDay !== undefined) {
      setMaxDay(props.maxDay);
    }

    if (props.minHour !== undefined) {
      setMinHour(props.minHour);
    }

    if (props.maxHour !== undefined) {
      setMaxHour(props.maxHour);
    }

    if (props.minMinutes !== undefined) {
      setMinMinutes(props.minMinutes);
    }

    if (props.maxMinutes !== undefined) {
      setMaxMinutes(props.maxMinutes);
    }
  }, [
    props.view,
    props.minDay,
    props.maxDay,
    props.minHour,
    props.maxHour,
    props.minMinutes,
    props.maxMinutes,
  ]);

  return (
    <>
      <div className="cus_num_field d-flex">
        <div className="holder">
          <p>Time</p>
        </div>
        <div className="inp">
          <input
            type="text"
            placeholder="Time"
            onFocus={() => setShowPickerDrop(true)}
            value={timeFieldLabelValue}
            readOnly
          />
          {showPickerDrop ? (
            <div className="picker_drop">
              <div className="header d-flex">
                {view.includes("day") && (
                  <div className="cols" style={{ width: colWidth }}>
                    days
                  </div>
                )}
                {view.includes("hour") && (
                  <div className="cols" style={{ width: colWidth }}>
                    hours
                  </div>
                )}
                {view.includes("minutes") && (
                  <div className="cols" style={{ width: colWidth }}>
                    mins
                  </div>
                )}
              </div>
              <div className="body d-flex">
                {view.includes("day") && (
                  <div className="cols" style={{ width: colWidth }}>
                    {Array.apply(null, { length: maxDay + 1 - minDay }).map(
                      (_, idx) => (
                        <span
                          key={`day-${idx}`}
                          onClick={() => {
                            const nextDay = idx + minDay;
                            setDay(nextDay);
                            applyDurationChange(nextDay, hour, minutes);
                          }}
                          className={` ${day == idx + minDay ? "active" : ""}`}
                        >
                          {idx + minDay}
                        </span>
                      )
                    )}
                  </div>
                )}

                {view.includes("hour") && (
                  <div className="cols" style={{ width: colWidth }}>
                    {Array.apply(null, { length: maxHour + 1 - minHour }).map(
                      (_, idx) => (
                        <span
                          key={`hour-${idx}`}
                          onClick={() => {
                            const nextHour = idx + minHour;
                            setHour(nextHour);
                            applyDurationChange(day, nextHour, minutes);
                          }}
                          className={` ${
                            hour == idx + minHour ? "active" : ""
                          }`}
                        >
                          {idx + minHour}
                        </span>
                      )
                    )}
                  </div>
                )}

                {view.includes("minutes") && (
                  <div className="cols" style={{ width: colWidth }}>
                    {Array.apply(null, {
                      length: maxMinutes + 1 - minMinutes,
                    }).map((_, idx) => (
                      <span
                        key={`minutes-${idx}`}
                        onClick={() => {
                          const nextMinutes = idx + minMinutes;
                          setMinutes(nextMinutes);
                          applyDurationChange(day, hour, nextMinutes);
                        }}
                        className={` ${
                          minutes == idx + minMinutes ? "active" : ""
                        }`}
                      >
                        {idx + minMinutes}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              <div className="foot d-flex align-items-center justify-content-end">
                <button
                    type="button"
                  className="btn rd_cancel"
                  onClick={() => setShowPickerDrop(false)}
                >
                  Ok
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default TimeField;
